import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { instance } from 'api/axiosClient';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const request = <T, R = AxiosResponse<T>, D = any>(config: AxiosRequestConfig<D>) => {
  return instance<T, R, D>(config);
};
